module.exports = __webpack_public_path__ + "static/media/example-03.f2ad06ba.jpg";